import { Button, Tile } from '@carbon/react';
import { MessageDescriptor, useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';

import { LocalPerson } from '../../../types';
import styles from '../../../InitialSetupModal.module.scss';

type Props = {
    people: LocalPerson[];
    personCategoryLabel: MessageDescriptor;
    getCategoryName: (categoryId: string) => string;
    onRemovePerson: (personId: string) => void;
};

const PeopleList = ({
    people,
    personCategoryLabel,
    getCategoryName,
    onRemovePerson,
}: Props) => {
    const intl = useIntl();

    return (
        <div className={styles.list}>
            {people.map((person) => (
                <Tile key={person.id} className={styles.personTile}>
                    <p className={styles.personTileTitle} title={`${person.firstName} ${person.lastName} - ${person.role}`}>
                        {person.firstName}
                        {' '}
                        {person.lastName}
                        {' - '}
                        {person.role}
                    </p>
                    <p className={styles.summaryLabel} title={getCategoryName(person.categoryId)}>
                        {intl.formatMessage(personCategoryLabel)}:
                        {' '}
                        {getCategoryName(person.categoryId)}
                    </p>
                    <Button
                        kind="danger--ghost"
                        size="sm"
                        className={styles.personRemoveButton}
                        onClick={() => { onRemovePerson(person.id); }}
                    >
                        {intl.formatMessage(sharedMessages.remove)}
                    </Button>
                </Tile>
            ))}
        </div>
    );
};

export default PeopleList;
